var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsentivesEmailSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113px",
    height: "104px",
    viewBox: "0 0 113 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Evolutions-2022",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bienvenue-2",
    transform: "translate(-141.000000, -231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(22.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(119.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6145376,49.8965268 L71.5705992,56.1523244 C70.8416849,56.5284344 69.9619916,56.4665271 69.2970563,55.9923266 C68.6321211,55.5181261 68.2956222,54.7127025 68.4273844,53.9107316 L70.7484283,40.6950024 L61.0294574,31.3568076 C60.4375623,30.790933 60.2250878,29.9395653 60.4821586,29.1638265 C60.7392294,28.3880877 61.4207828,27.8239592 62.2377263,27.7107259 L75.6928896,25.7597826 L81.7295406,13.7325767 C82.0977814,13.0019092 82.8518265,12.5390707 83.6761711,12.5377178 C84.5005156,12.5363708 85.2530377,12.996742 85.6188696,13.7262074 L91.6158688,25.7337066 L105.064668,27.640591 C105.878689,27.7551075 106.554838,28.3170668 106.808745,29.0901233 C107.062652,29.8631799 106.850266,30.7132185 106.260913,31.2827349 L96.5110773,40.6528125 L98.7829964,53.8555403 C98.9221132,54.6587566 98.5867684,55.4717814 97.9185218,55.9514106 C97.2502752,56.4310398 96.3655819,56.4936886 95.6378997,56.1129109 L83.6145376,49.8965268 L83.6145376,49.8965268 Z",
    id: "Path",
    strokeWidth: 3.36,
    transform: "translate(83.644496, 34.467166) rotate(12.000000) translate(-83.644496, -34.467166) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.8441036,
    y1: 63.6289575,
    x2: 60.8441036,
    y2: 100.184425,
    id: "Line-4",
    strokeWidth: 3.4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.5744328,
    y1: 63.6289575,
    x2: 50.5744328,
    y2: 100.184425,
    id: "Line-4-Copy",
    strokeWidth: 3.4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 3.4,
    x: 32.0774135,
    y: 62.9519902,
    width: 47.2637093,
    height: 37.3480098,
    rx: 3.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(30.643439, 48.944981) rotate(-54.000000) translate(-30.643439, -48.944981) translate(-0.507896, 33.819815)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 3.2,
    x: 1.6,
    y: 18.2676635,
    width: 59.1026695,
    height: 10.3826699,
    rx: 3.4,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8409032,3.24372143 C42.6300787,3.23746761 44.2483972,3.9503471 45.4171941,5.1111886 C46.5818376,6.26790479 47.2990646,7.86902239 47.2928979,9.64031093 C47.2839842,12.1842533 44.9948702,16.096624 40.7576341,21.4348559 C36.5695231,16.1379929 34.3116737,12.2487074 34.3205258,9.70935067 C34.3267472,7.93149725 35.0596445,6.32045652 36.2363481,5.15161559 C37.4171596,3.97869419 39.0453082,3.25003882 40.8409032,3.24372143 Z",
    id: "Oval",
    strokeWidth: 3.36,
    transform: "translate(40.806712, 12.837662) rotate(-300.000000) translate(-40.806712, -12.837662) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.376881,3.07727413 C26.1660565,3.07102031 27.7843749,3.7838998 28.9531719,4.9447413 C30.1178153,6.10145749 30.8350424,7.70257509 30.8288757,9.47386363 C30.819962,12.017806 28.530848,15.9301767 24.2936118,21.2684086 C20.1055009,15.9715456 17.8476515,12.0822601 17.8565036,9.54290337 C17.862725,7.76504995 18.5956223,6.15400922 19.7723259,4.98516829 C20.9531374,3.81224689 22.581286,3.08359152 24.376881,3.07727413 Z",
    id: "Oval",
    strokeWidth: 3.36,
    transform: "translate(24.342690, 12.671214) scale(-1, 1) rotate(-300.000000) translate(-24.342690, -12.671214) "
  })), /*#__PURE__*/React.createElement("line", {
    x1: 91.5517029,
    y1: 0,
    x2: 90.1416306,
    y2: 6.10928272,
    id: "Path-12",
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.2007576,
    y1: 3.03342202,
    x2: 75.6515522,
    y2: 8.28344244,
    id: "Path-12",
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.609673,
    y1: 11.2915923,
    x2: 101.491372,
    y2: 14.9662091,
    id: "Path-12",
    strokeWidth: 3.4
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsentivesEmailSuccess);
export default __webpack_public_path__ + "static/media/insentives_email_success.f43312140d8d65c9aa0cd7694d8b1caf.svg";
export { ForwardRef as ReactComponent };